module.exports = __webpack_public_path__ + "img/star-full.9b4783e0.svg";